import styled from 'styled-components'
import { TransparentButton } from 'common/button'
import Share from 'common/share'
import Favorite from 'components/icons/favorite'
import useLocation from 'hooks/use-location'
import { useLesson } from 'querys/lesson'
import { useLessonFavorite } from 'mutations/lesson'

const ClassFeaturesStyled = styled.div`
  display: flex;
  ${TransparentButton} {
    margin-right: 16px;
  }
  .favorite {
    position: relative;
    &:hover .tooltip-favorite {
      visibility: visible;
      opacity: 1;
    }
  }
  .tooltip-favorite {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    background: var(--baseSecondary);
    color: var(--basePrimary);
    font-size: 13px;
    text-align: center;
    padding: 4px 8px;
    border-radius: 6px;
    width: 100px;
    bottom: -48px;
    right: 16px;
  }
  @media(min-width: 1024px) {
    grid-area: features;
  }
`

function ClassFeatures() {
  const { data: { title, meta, favorite } } = useLesson()
  const { mutate: markAsFavorite } = useLessonFavorite()
  const { href } = useLocation()
  return (
    <ClassFeaturesStyled>
      <div className="favorite">
        <TransparentButton onClick={() => markAsFavorite(!favorite)}>
          <Favorite
            stroke={!favorite && 'var(--neutralText)'}
            color={favorite && '#FFDD66'}
          />
        </TransparentButton>
        <div className="tooltip-favorite">
          Marcar como favorita
        </div>
      </div>
      <Share
        position="bottomLeft"
        url={href}
        title={title}
        text={meta}
        color="var(--neutralText)"
      />
    </ClassFeaturesStyled>
  )
}

export default ClassFeatures
